import * as scenarioHelpers from './scenarios';

export const FILE_COMPARE_RESULT = 'FILE_COMPARE_RESULT';
export const INSTALLER_TEST_RESULT = 'INSTALLERTEST_RESULT';
export const OVERINSTALL_RESULT = 'OVERINSTALL_RESULT';
export const POST_UPDATE_RESULT = 'POSTUPDATE_RESULT';
export const INSTALL_RESULT = 'INSTALL_RESULT';
export const PRE_UPDATE_RESULT = 'PREUPDATE_RESULT';
export const WHITE_TEST_RESULT = 'WHITE_TEST_RESULT';

export const RESULT_KEY = '_RESULT';
export const ACTUAL_KEY = '_ACTUAL';
export const EXPECTED_KEY = '_EXPECTED';

export const FILE_COMPARE_KEY = 'FILE_COMPARE';
export const INSTALLER_TEST_KEY = 'INSTALLERTEST';
export const OVERINSTALL_KEY = 'OVERINSTALL';
export const POST_UPDATE_KEY = 'POSTUPDATE';
export const INSTALL_KEY = 'INSTALL';
export const PRE_UPDATE_KEY = 'PREUPDATE';
export const WHITE_TEST_KEY = 'WHITE_TEST';

export const MISSING_PREPACK_PRESENCE = 'Missing from Pre-Update Delta Pack';
export const MISSING_POSTPACK_PRESENCE = 'Missing from Post-Update Delta Pack';

export const INSTALLER_TEST_METRIC_KEYS = [
  INSTALL_KEY,
  OVERINSTALL_KEY,
  PRE_UPDATE_KEY,
  WHITE_TEST_KEY,
  POST_UPDATE_KEY,
  FILE_COMPARE_KEY
];

export const INSTALLER_TEST_METRICS_PRETTY_NAMES = {
  [INSTALL_KEY]: 'Install',
  [OVERINSTALL_KEY]: 'OverInstall',
  [PRE_UPDATE_KEY]: 'Delta Pack',
  [WHITE_TEST_KEY]: 'White Test',
  [POST_UPDATE_KEY]: 'Delta Pack',
  [FILE_COMPARE_KEY]: 'File Compare'
};

export const getInstallerBadge = (installerMetrics) => {
  const unexpectedChanges =
    installerMetrics.added.unexpected + installerMetrics.removed.unexpected;
  const noChanges =
    installerMetrics.noFiles.buildId + installerMetrics.noFiles.baselineBuildId;

  let text = 'No Changes';
  let style = 'primary';

  if (unexpectedChanges > 0) {
    text = `${unexpectedChanges} Unexpected Changes`;
    style = 'danger';
  }

  if (noChanges > 0)
  {
    text = 'No files in ';
    if (installerMetrics.noFiles.buildId === 1)
      text += 'build ';
    if (noChanges === 2)
      text += 'or ';
    if (installerMetrics.noFiles.baselineBuildId === 1)
      text += 'baseline';
  }

  return {
    text: text,
    style: style
  };
};

export const scenarioVerdictFromMetrics = (metrics, scenarioStatus) => {
  const testResult = metrics &&
    metrics[INSTALLER_TEST_RESULT] &&
    metrics[INSTALLER_TEST_RESULT].toUpperCase();
  const compareResult = metrics &&
    metrics[FILE_COMPARE_RESULT] &&
    metrics[FILE_COMPARE_RESULT].toUpperCase();

  if ((testResult === 'FALSE' || compareResult === 'FALSE') &&
    scenarioHelpers.isScenarioComplete(scenarioStatus))
  {
    return scenarioHelpers.SCENARIO_FAILED;
  }
  else if (testResult === 'TRUE' && compareResult === 'TRUE') {
    return scenarioHelpers.SCENARIO_COMPLETED;
  }
  else {
    return scenarioStatus;
  }
};


// WEBPACK FOOTER //
// src/helpers/installer.js